import { useQuery } from '@apollo/client';
import { GET_BUSINESS_FUNCTIONS_METRICS } from '../graphql';
import type {
  GetBusinessFunctionsMetricsData,
  GetBusinessFunctionsMetricsVars,
} from '../types';

/**
 * Hook to fetch business functions metrics
 * @param locationUUID - The UUID of the location to fetch the data for. If not provided, the data will be fetched for enterprise level.
 * @returns {{ data: CyberHubBusinessFunctionsMetrics }}
 */
export const useBusinessFunctionsMetrics = (locationUUID?: string) => {
  const result = useQuery<
    GetBusinessFunctionsMetricsData,
    GetBusinessFunctionsMetricsVars
  >(GET_BUSINESS_FUNCTIONS_METRICS, {
    variables: { locationUUID },
  });

  // Debug logging
  if (result.error) {
    console.error('useBusinessFunctionsMetrics GraphQL error:', result.error);
  }

  return {
    data: result.data?.getBusinessFunctionsMetrics,
    loading: result.loading,
    error: result.error,
  };
};
